// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
export class FetchError extends Error {
  constructor(
    message: string,
    public status = 500,
    public code?: string,
    public requestId?: string
  ) {
    super(message);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, FetchError);
    }

    this.name = 'FetchError';
  }
}

// Walks an error's `cause` chain (bounded) looking for the FetchError that started it. Callers that
// wrap an API failure with their own context -- `new Error('Unable to X: ...', { cause: error })` --
// would otherwise hide the backend requestId and code from the error dialog's reference ID.
export const findFetchError = (error: unknown): FetchError | undefined => {
  let current: unknown = error;
  for (let depth = 0; depth < 5 && current !== undefined && current !== null; depth += 1) {
    if (current instanceof FetchError) {
      return current;
    }
    current = current instanceof Error ? current.cause : undefined;
  }
  return undefined;
};
